import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { connect } from "react-redux";
import Select from "react-select";
import cookie from "react-cookies";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import $ from "jquery";
import moment from "moment";
import { ecommerceapiUrl, clientheaderconfig } from "../../Helpers/Config";
import { GET_LISTDATA } from "../../../actions";
import { showLoader, showAlert, hideLoader, showDate, showPriceValue } from "../../Helpers/SettingHelper";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
var module = "order/kitchen-display";
const { format, subHours } = require("date-fns");

class List extends Component {
  constructor(props) {
    super(props);
    var companyID = cookie.load("companyID");

    this.state = {
      moduleName: "Kitchen Display",
      companyID: companyID,
      path: this.props?.location?.pathname || "",
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      listsearchdata: [],
      loading: false,
      outletList: [],
      searchoption: "",
      start_date: "",
      end_date: "",
      order_outlet: [],
      popupType: "",
      orderDatasOriginal: [],
      orderDatas: [],
      totalItemCount: 0,
      orderInvoiceDatas: [],
      orderInvoiceDatasOriginal: [],
      selectedItem: "",
      selectCompleteItem: [],
      selectedOrderItem: [],
      itemname: "",
      activeTab: "itemwise",
      orderkeyword: "",
    };
    this.handleChangeText = this.handleChangeText.bind(this);
    this.timerID = null; 
  }
  componentDidMount() {
    this.loadOutlet();
    this.setState({ loading: true }, function () {
      this.loadList();
      this.timerID = setInterval(() => {
        this.loadList();
      }, 10000);
    });
  }
  componentWillUnmount() {
    if (this.timerID) {
      clearInterval(this.timerID);
    }
  }


  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listsearchdata !== this.state.listdata) {
      this.setState({
        listdata: nextProps.listdata,
        listsearchdata: nextProps.listdata,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
      });
    }
  }
  loadOutlet() {
    var urlShringTxt = ecommerceapiUrl + "outlet/dropDownList";
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ outletList: res.data.result });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        function () {
          this.loadList(value);
        },
      );
    }
  };
  searchList() {
    this.setState({ loading: true }, function () {
      this.loadList();
    });
  }
  loadList() {
    var addParams = "";

    const clientAllowOutlet = cookie.load("clientAllowOutlet") ?? "";
    if (clientAllowOutlet !== "") {
      addParams += "&storeID=" + cookie.load("clientAllowOutlet");
    } else {
      let orderOutlet = this.state.order_outlet.length > 0 ? this.state.order_outlet.map((item) => item.value) : [];
      if(orderOutlet.length>0) {
        console.log(orderOutlet, 'orderOutlet')
        addParams += `&storeID=${orderOutlet.join(',')}`
      }
    }

    if (this.state.start_date !== "" && this.state.end_date !== "") {
      addParams += "&start_date=" + moment(this.state.start_date).format("Y-MM-DD HH:mm:ss") + "&end_date=" + moment(this.state.end_date).format("Y-MM-DD HH:mm:ss");
    } else if (this.state.start_date !== "" && this.state.end_date !== "") {
      addParams += "&start_date=" + moment(this.state.start_date).format("Y-MM-DD HH:mm:ss");
    } else {
      addParams += "&start_date=" + moment(new Date()).format("YYYY-MM-DD") + " 00:00:00" + "&end_date=" + moment(new Date()).format("YYYY-MM-DD") + " 23:59:59";
    }

    var urlShringTxt = `${ecommerceapiUrl}${module}?${addParams}`;
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          const searchKeyword = this.state.itemname;
          
          this.setState(
            { orderDatasOriginal: res.data.result, orderInvoiceDatas: res.data.itemList, orderInvoiceDatasOriginal: res.data.itemList, loading: false },
            () => {
              if(searchKeyword==="") {
                this.setState({ orderDatas: res.data.result})
              }else {
                this.filterorderDatas();
              }
              let totalItemCount = 0;
              if (res.data.result.length > 0) {
                res.data.result.map((item) => {
                  if (item.product.length > 0) {
                    item.product.map((pItem) => {
                      const completedQuantity = parseInt(pItem?.completedQuantity || 0) ?? 0;
                      const totalQuantity = parseInt(pItem?.quantity || 0) ?? 0;
                      const percent = parseFloat(totalQuantity) > 0 ? (completedQuantity / totalQuantity) * 100 : 0;

                      const currentQty = parseInt(pItem.quantity) !== parseInt(completedQuantity) ? parseInt(pItem.quantity) - parseInt(completedQuantity) : pItem.quantity;
                      totalItemCount += parseInt(currentQty);
                      return pItem;
                    });
                  }
                  return item;
                });
              }
              this.setState({totalItemCount})
            },
          );
        }
      })
      .catch((e) => {
        console.log(e);
        this.setState({ orderDatas: [], orderDatasOriginal: [], totalItemCount: 0, loading: false });
        
      });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }
  handleChangeDate(name, value) {
    this.setState({ [name]: value });
  }
  handleChangeText(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({ [name]: value }, () => {
      if (name === "itemname") {
        this.filterorderDatas();
      } else if (name === "orderkeyword") {
        this.filterorders();
      }
    });
  }
  filterorderDatas() {
    console.log(this.state.itemname, 'this.state.itemname')
    const searchKeywor = (this.state.itemname!=="")?this.state.itemname.toLowerCase():'';
    const result =
      searchKeywor !== ""
        ? this.state.orderDatasOriginal.length > 0
          ? this.state.orderDatasOriginal
              .map((day) => ({
                ...day,
                product: day.product.filter((item) => item.productName.toLowerCase().includes(this.state.itemname.toLowerCase())),
              }))
              .filter((day) => day.product.length > 0)
          : []
        : this.state.orderDatasOriginal;
    this.setState({ orderDatas: result });
  }

  filterorders() {
    const searchKeyword = this.state.orderkeyword.toLowerCase();

    const result =
      searchKeyword !== ""
        ? this.state.orderInvoiceDatasOriginal
            .map((order) => {
              const orderMatch = order.orderNumber.toLowerCase().includes(searchKeyword);

              const filteredItems = order.orderitems.filter((item) => item.orderItemProductName.toLowerCase().includes(searchKeyword) || order.orderNumber.toLowerCase().includes(searchKeyword));

              if (orderMatch || filteredItems.length > 0) {
                return {
                  ...order,
                  orderitems: filteredItems,
                };
              }

              return null;
            })
            .filter((o) => o !== null)
        : this.state.orderInvoiceDatasOriginal;
    this.setState({ orderInvoiceDatas: result });
  }

  resetSearch() {
    this.setState(
      {
        loading: true,
        listdata: [],
        searchoption: "",
        start_date: "",
        end_date: "",
        order_outlet: "",
        totalRecords: 0,
        totalPage: 0,
      },
      function () {
        this.loadList(1);
      },
    );
  }
  viewitem(selectedItem, popupType) {
    this.setState({ selectedItem, popupType }, () => {
      $("#openmodel")
        .click(function () {
          this.click();
        })
        .click();
    });
  }
  selectItem(itemID, comboIndex, orderItemProductID) {
    let selectCompleteItem = this.state.selectCompleteItem;
    let checkExist = selectCompleteItem.findIndex((acc) => acc?.itemID === itemID);
    if (checkExist >= 0) {
      selectCompleteItem.splice(checkExist, 1);
    } else {
      selectCompleteItem.push({ itemID, comboIndex, orderItemProductID });
    }
    this.setState({ selectCompleteItem });
  }

  completeItem() {
    const selectCompleteItem = this.state.selectCompleteItem;
    if (selectCompleteItem.length > 0) {
      var postObject = {
        selectCompleteItem: JSON.stringify(selectCompleteItem),
      };
      showLoader("completeItem");
      axios
        .put(`${ecommerceapiUrl}order/change-kitchen-status`, postObject, clientheaderconfig)
        .then((res) => {
          hideLoader("completeItem");
          if (res.data.status === "ok") {
            this.setState({ selectCompleteItem: [], selectedItem: "" }, () => {
              this.loadList(1);
            });
            $("#modalCenter #btn-close")
              .click(function () {
                this.click();
              })
              .click();
            setTimeout(() => {
              showAlert("Success", "Product updates success", "success", "No");
            }, 200);
          }
        })
        .catch((e) => {
          hideLoader("completeItem");
          console.log(e);
        });
    } else {
    }
  }

  selectOrderItem(itemID) {
    let selectedOrderItem = this.state.selectedOrderItem;
    if (selectedOrderItem.indexOf(itemID) >= 0) {
      selectedOrderItem.splice(selectedOrderItem.indexOf(itemID), 1);
    } else {
      selectedOrderItem.push(itemID);
    }
    this.setState({ selectedOrderItem });
  }

  completeOrder() {
    const selectedOrderItem = this.state.selectedOrderItem;
    if (selectedOrderItem.length > 0) {
      var postObject = {
        selectCompleteItem: selectedOrderItem.join(","),
      };
      showLoader("completeItem");
      axios
        .put(`${ecommerceapiUrl}order/change-item-kitchen-status`, postObject, clientheaderconfig)
        .then((res) => {
          hideLoader("completeItem");
          if (res.data.status === "ok") {
            this.setState({ selectedOrderItem: [], selectedItem: "" }, () => {
              this.loadList(1);
            });
            $("#modalCenter #btn-close")
              .click(function () {
                this.click();
              })
              .click();
            setTimeout(() => {
              showAlert("Success", "Product updates success", "success", "No");
            }, 200);
          }
        })
        .catch((e) => {
          hideLoader("completeItem");
          console.log(e);
        });
    } else {
      showAlert("Error", "Please select any one item", "error", "No");
    }
  }

  completeOrderItem = async (orderID) => {
    const $_this = this;
    Swal.fire({
      title: "Are you sure?",
      text: "You want confirm this order!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, confirm!",
      customClass: {
        confirmButton: "btn btn-primary me-3 waves-effect waves-light",
        cancelButton: "btn btn-label-secondary waves-effect",
      },
      buttonsStyling: false,
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        const postObject = {
          orderID,
        };
        return axios
          .put(`${ecommerceapiUrl}order/change-kitchen-order-status`, postObject, clientheaderconfig)
          .then((res) => {
            return res.data;
          })
          .catch((e) => {
            console.log(e);
          });
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      const value = result?.value ?? "";
      if (value !== "") {
        if (value.status === "ok") {
          $_this.setState({ selectedItem: "" });
          $_this.loadList(1);
          Swal.fire({
            icon: "success",
            title: "Confirm!",
            text: value.message,
            customClass: {
              confirmButton: "btn btn-success waves-effect",
            },
          });
        } else {
          Swal.fire({
            title: "Alert",
            text: value.message,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-danger waves-effect",
            },
          });
        }
      }
      return "";
    });
  };
  applyTab(activeTab) {
    this.setState({ activeTab });
  }

  displyComboItems(orderItemComboSet) {
    try {
      const orderItemComboSet_ = JSON.parse(orderItemComboSet);
      if (orderItemComboSet_.length > 0) {
        return orderItemComboSet_.map((citem) => {
          if (citem.products.length > 0) {
            return citem.products.map((cpItem) => {
              return <span>{cpItem.productName}</span>;
            });
          } else {
            return "";
          }
        });
      }
    } catch (e) {
      return "";
    }
  }

  render() {
    const clientAllowOutlet_ = cookie.load("clientAllowOutlet") ?? "";
    const selectedItem = this.state.selectedItem ?? "";
    let percent_ = "";
    let completedQuantity_ = 0;
    let totalQuantity_ = 0;
    /* let orderKitchenCompleted_ = false; */

    if (selectedItem !== "") {
      if (this.state.popupType === "itemwise") {
        completedQuantity_ = parseInt(selectedItem?.completedQuantity || 0) ?? 0;
        totalQuantity_ = parseInt(selectedItem?.quantity || 0) ?? 0;
        percent_ = parseFloat(totalQuantity_) > 0 ? (completedQuantity_ / totalQuantity_) * 100 : 0;
        if (completedQuantity_ === 0) {
          percent_ = 100;
        }
      } else {
        completedQuantity_ = parseInt(selectedItem?.completedItem || 0) ?? 0;
        totalQuantity_ = parseInt(selectedItem?.totalItem || 0) ?? 0;
        percent_ = parseFloat(totalQuantity_) > 0 ? (completedQuantity_ / totalQuantity_) * 100 : 0;
        /*  orderKitchenCompleted_ = selectedItem?.orderKitchenCompleted ?? false; */
      }
    }

    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"kitchen-display"} />
          <div className="layout-page">
            <Topmenu />

            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">{this.state.moduleName}</h4>
                  </div>
                </div>
                <div className="row mb-4">
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline">
                      <DatePicker
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        showTimeSelect
                        dropdownMode="select"
                        className="form-control"
                        selected={this.state.start_date}
                        dateFormat="dd-MM-yyyy h:mm aa"
                        placeholderText="Start Date"
                        onChange={this.handleChangeDate.bind(this, "start_date")}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline">
                      <DatePicker
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        showTimeSelect
                        dropdownMode="select"
                        className="form-control"
                        selected={this.state.end_date}
                        minDate={this.state.start_date !== "" ? this.state.start_date : ""}
                        dateFormat="dd-MM-yyyy h:mm aa"
                        placeholderText="End Date"
                        onChange={this.handleChangeDate.bind(this, "end_date")}
                      />
                    </div>
                  </div>
                  {clientAllowOutlet_ === "" && (
                    <div className="col-md-4">
                      <div className="form-floating form-floating-outline">
                        <Select
                          placeholder={"Select Outlet"}
                          value={this.state.order_outlet}
                          options={this.state.outletList}
                          onChange={this.handleSelectChange.bind(this, "order_outlet")}
                          isClearable={true}
                          isMulti
                        />
                      </div>
                    </div>
                  )}
                  <div className="col-md-3 mt-2">
                    <button type="button" className="btn btn-primary me-sm-2 me-1 waves-effect waves-light" onClick={this.searchList.bind(this)}>
                      Search
                    </button>
                    <button type="reset" className="btn btn-label-secondary waves-effect me-sm-2 me-1" onClick={this.resetSearch.bind(this)}>
                      Reset
                    </button>
                  </div>
                </div>

                <a href="/" className="hidden" data-bs-toggle="modal" data-bs-target="#modalCenter" id="openmodel">
                  Launch modal
                </a>
                <div className="card mb-4">
                  <div className="card-header">
                    <div className="nav-align-top">
                      <div className="row mb-3">
                        <div className="col-lg-7 col-md-7">
                          <ul className="nav nav-tabs" role="tablist">
                            <li className="nav-item">
                              <button
                                type="button"
                                className="nav-link active"
                                role="tab"
                                data-bs-toggle="tab"
                                data-bs-target="#navs-justified-home"
                                aria-controls="navs-justified-home"
                                aria-selected="true"
                                onClick={this.applyTab.bind(this, "itemwise")}
                              >
                                <i className="tf-icons mdi mdi-sitemap-outline me-1"></i> Item Wise
                              </button>
                            </li>
                            <li className="nav-item">
                              <button
                                type="button"
                                className="nav-link"
                                role="tab"
                                data-bs-toggle="tab"
                                data-bs-target="#navs-justified-profile"
                                aria-controls="navs-justified-profile"
                                aria-selected="false"
                                onClick={this.applyTab.bind(this, "invoice")}
                              >
                                <i className="mdi mdi-receipt-text-outline me-1"></i> Invoice
                              </button>
                            </li>
                          </ul>
                        </div>
                        <div className="col-md-2">
                   <div className="form-floating form-floating-outline mb-4 align-items-edn">
                            <h3 class="mb-0">Total Items:{this.state.totalItemCount}</h3>
                            </div>
                        </div>
                        <div className="col-md-3">
                          {this.state.activeTab === "itemwise" && (
                            <>
                           
                            <div className="form-floating form-floating-outline mb-4 align-items-edn">
                              
                              <input type="text" className="form-control" name="itemname" onChange={this.handleChangeText} value={this.state.itemname} />
                              <label htmlFor="name">Search Item</label>
                            </div>
                            </>
                          )}
                          {this.state.activeTab === "invoice" && (
                            <div className="form-floating form-floating-outline mb-4 align-items-edn">
                              <input type="text" className="form-control" name="orderkeyword" onChange={this.handleChangeText} value={this.state.orderkeyword} />
                              <label htmlFor="name">Search Invoice Or Item</label>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="tab-content p-0">
                      <div className="tab-pane fade show active" id="navs-justified-home" role="tabpanel">
                        <div className="kitchen-cards">
                          {this.state.loading === true ? (
                            <div className="spinner-border spinner-border-lg text-primary" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          ) : this.state.orderDatas.length > 0 ? (
                            this.state.orderDatas.map((item) => {
                              return (
                                item.product.length > 0 &&
                                item.product.map((pItem) => {
                                  const completedQuantity = parseInt(pItem?.completedQuantity || 0) ?? 0;
                                  const totalQuantity = parseInt(pItem?.quantity || 0) ?? 0;
                                  const percent = parseFloat(totalQuantity) > 0 ? (completedQuantity / totalQuantity) * 100 : 0;
                                  return (
                                    <div className="kitchen-card" onClick={this.viewitem.bind(this, pItem, "itemwise")}>
                                      <div className="kitchen-card-lhs">
                                        <span className="kitchen-date">{item.orderDate}</span>
                                        <h3>{pItem.productName}</h3>
                                      </div>
                                      <div className="kitchen-card-rhs">
                                        {/* <div className="kitchen-status delivery">DELIVERY</div> */}
                                        <div
                                          className={`kitchen-circle ${completedQuantity === totalQuantity ? "kitchen-green" : completedQuantity > 0 ? "kitchen-orange" : "kitchen-red"}`}
                                          style={{ "--percent": completedQuantity === 0 ? 100 : percent }}
                                        >
                                          <span>{parseInt(pItem.quantity) !== parseInt(completedQuantity) ? parseInt(pItem.quantity) - parseInt(completedQuantity) : pItem.quantity}</span>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })
                              );
                            })
                          ) : (
                            <div>No Record Found</div>
                          )}
                        </div>
                      </div>
                      <div className="tab-pane fade" id="navs-justified-profile" role="tabpanel">
                        <div className="kitchen-cards">
                          {this.state.loading === true ? (
                            <div className="spinner-border spinner-border-lg text-primary" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          ) : this.state.orderInvoiceDatas.length > 0 ? (
                            this.state.orderInvoiceDatas.map((item, index) => {
                              const completedQuantity = parseInt(item?.completedItem || 0) ?? 0;
                              const totalQuantity = parseInt(item?.totalItem || 0) ?? 0;
                              const percent = parseFloat(totalQuantity) > 0 ? (completedQuantity / totalQuantity) * 100 : 0;
                              const orderKitchenCompleted = item?.orderKitchenCompleted ?? false;
                              let btnLabel = "Pending";
                              let btnClass = "danger";
                              if (completedQuantity === totalQuantity || orderKitchenCompleted === true) {
                                btnLabel = "Completed";
                                btnClass = "success";
                              } else if (completedQuantity > 0) {
                                btnLabel = "Partially Completed";
                                btnClass = "warning";
                              }

                              return (
                                <div className="kitchen-card-parent" key={index}>
                                  <h2 className="kitchen-card-ordernumber">{item.orderNumber}</h2>
                                  <div className="kitchen-card-child" onClick={this.viewitem.bind(this, item, "orderwise")}>
                                    <div className="kitchen-card-lhs">
                                      <span className="kitchen-date">{showDate(item.orderDate)}</span>
                                      <span className="kitchen-date">{item.orderTime}</span>

                                      {item.orderitems.length > 0 &&
                                        item.orderitems.map((pItem) => {
                                          const orderItemComboSet = pItem?.orderItemComboSet || "";
                                          let displayCombItem = "";

                                          if (orderItemComboSet !== "" && orderItemComboSet !== null) {
                                            displayCombItem = this.displyComboItems(orderItemComboSet);
                                          }
                                          return (
                                            <h3>
                                              {pItem.orderItemProductName} {orderItemComboSet && <> - {this.displyComboItems(orderItemComboSet)}</>} X {pItem.orderItemQuantity}
                                            </h3>
                                          );
                                        })}
                                    </div>
                                    <div className="kitchen-card-rhs">
                                      <div className="kitchen-status delivery">{item.orderAvailabilityName}</div>
                                      <div
                                        className={`kitchen-circle ${
                                          completedQuantity === totalQuantity || orderKitchenCompleted === true ? "kitchen-green" : completedQuantity > 0 ? "kitchen-orange" : "kitchen-red"
                                        }`}
                                        style={{ "--percent": completedQuantity === 0 ? 100 : percent }}
                                      >
                                        <span>{parseInt(totalQuantity) !== parseInt(completedQuantity) ? parseInt(totalQuantity) - parseInt(completedQuantity) : totalQuantity}</span>
                                      </div>
                                    </div>
                                  </div>

                                  <div>
                                    <button
                                      type="button"
                                      className={`btn btn-${btnClass} me-sm-2 me-1 waves-effect waves-light kitchen-card-btn`}
                                      onClick={this.completeOrderItem.bind(this, item._id)}
                                    >
                                      {btnLabel}
                                    </button>
                                  </div>
                                </div>
                              );
                            })
                          ) : (
                            <div>No Record Found</div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="modal fade" id="modalCenter" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
          <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-body">
                {selectedItem !== "" && this.state.popupType === "itemwise" && (
                  <div className="order-card">
                    <div className="order-header">
                      <div
                        className={`kitchen-circle  ${completedQuantity_ === totalQuantity_ ? "kitchen-green" : completedQuantity_ > 0 ? "kitchen-orange" : "kitchen-red"}`}
                        style={{ "--percent": percent_ }}
                      >
                        <span>{parseInt(totalQuantity_) !== parseInt(completedQuantity_) ? parseInt(totalQuantity_) - parseInt(completedQuantity_) : totalQuantity_}</span>
                      </div>
                      <div className="order-info">
                        <h3>{selectedItem.productName}</h3>
                        <p>
                          {totalQuantity_} orders, {completedQuantity_} completed
                        </p>
                      </div>
                      {/* <span className="order-badge">DELIVERY</span> */}
                    </div>

                    <table className="order-table">
                      <thead>
                        <tr>
                          <th>Invoice No</th>
                          <th>Date &amp; Time</th>
                          <th>Items</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedItem.itemDetails.map((item, index) => {
                          let checkExist = this.state.selectCompleteItem.some((acc) => acc?.itemID === item.itemID);

                          return (
                            <tr key={index}>
                              <td>{item.orderNumber}</td>
                              <td>{format(subHours(new Date(item.orderDate), 8), "dd-MM-yyyy hh:mm a")}</td>
                              <td>{item.quantity}</td>
                              <td>
                                <div className="form-check mt-3">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="defaultCheck1"
                                    onChange={this.selectItem.bind(this, item.itemID, item.orderItemComboSet, selectedItem.orderItemProductID)}
                                    disabled={parseInt(item.completedCount) > 0 ? true : false}
                                    checked={checkExist || parseInt(item.completedCount) > 0 ? true : false}
                                  />
                                  <label className="form-check-label" htmlFor="defaultCheck1">
                                    {" "}
                                    &nbsp;{" "}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
                {selectedItem !== "" && this.state.popupType === "orderwise" && (
                  <div className="order-card">
                    <div className="order-header">
                      <div
                        className={`kitchen-circle ${completedQuantity_ === totalQuantity_ ? "kitchen-green" : completedQuantity_ > 0 ? "kitchen-orange" : "kitchen-red"}`}
                        style={{ "--percent": percent_ }}
                      >
                        <span>{parseInt(totalQuantity_) !== parseInt(completedQuantity_) ? parseInt(totalQuantity_) - parseInt(completedQuantity_) : totalQuantity_}</span>
                      </div>
                      <div className="order-info">
                        <h3>{selectedItem.orderNumber}</h3>
                        <p>
                          {totalQuantity_} item, {completedQuantity_} completed
                        </p>
                        <span className="kitchen-date">
                          {showDate(selectedItem.orderDate)} {selectedItem.orderTime}
                        </span>
                      </div>
                      <span className="order-badge">{selectedItem.orderAvailabilityName}</span>
                    </div>

                    <table className="order-table">
                      <thead>
                        <tr>
                          <th>Menu</th>
                          <th>Qty</th>
                          {/*  <th>Price</th> */}
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedItem.orderitems.length > 0
                          ? selectedItem.orderitems.map((item, index) => {
                              const orderItemKitchenCompletedQuantity__ = item?.orderItemKitchenCompletedQuantity || 0;

                              const orderItemComboSet = item?.orderItemComboSet || "";
                              let displayCombItem = "";

                              if (orderItemComboSet !== "" && orderItemComboSet !== null) {
                                displayCombItem = this.displyComboItems(orderItemComboSet);
                              }

                              return (
                                <tr key={index}>
                                  <td>
                                    {item.orderItemProductName} {orderItemComboSet && <> - {this.displyComboItems(orderItemComboSet)}</>}
                                  </td>
                                  <td valign="top">{item.orderItemQuantity}</td>
                                  {/* <td valign="top">{showPriceValue(item.orderItemTotalPrice)}</td> */}
                                  <td valign="top">
                                    <div className="form-check mt-3">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value=""
                                        id={`defaultCheck${index}`}
                                        onChange={this.selectOrderItem.bind(this, item._id)}
                                        disabled={parseInt(orderItemKitchenCompletedQuantity__) > 0 ? true : false}
                                        checked={this.state.selectedOrderItem.indexOf(item._id) >= 0 || parseInt(orderItemKitchenCompletedQuantity__) > 0 ? true : false}
                                      />
                                      <label className="form-check-label" htmlFor={`defaultCheck${index}`}>
                                        {" "}
                                        &nbsp;{" "}
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                          : ""}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-label-secondary" id="btn-close" data-bs-dismiss="modal">
                  Close
                </button>
                {this.state.popupType === "itemwise" && totalQuantity_ !== completedQuantity_ && (
                  <button type="button" className="btn btn-primary" id="completeItem" onClick={this.completeItem.bind(this)}>
                    Complete
                  </button>
                )}
                {this.state.popupType === "orderwise" && totalQuantity_ !== completedQuantity_ && (
                  <button type="button" className="btn btn-primary" id="completeOrder" onClick={this.completeOrder.bind(this)}>
                    Complete
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var listdata = [];
  var totalPages = 0;
  var totalRecords = 0;
  if (Object.keys(state.listdata).length > 0) {
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(List));
